import { usePageParamsFromSchema } from 'src/hooks/use-page-params-from-schema';
import { shipperTransactionsPageParamsSchema } from 'src/pages/reporting/shipper-transactions/schema';

export function useShipperTransactionsPageParams() {
  return usePageParamsFromSchema(shipperTransactionsPageParamsSchema, {
    filters: {
      createdAtStart: { label: 'Time of Creation' },
      createdAtEnd: { label: 'Time of Creation' },
      shipperId: { label: 'Shipper' },
      networkPointId: { label: 'Network Point' },
      direction: { label: 'Direction' },
      marketAreaId: { label: 'Market Area' },
      capacityCategoryId: { label: 'Category' },
      productType: { label: 'Product' },
      runtimeIntersectionFilterStart: { label: 'Runtime' },
      runtimeIntersectionFilterEnd: { label: 'Runtime' },
      transactionType: { label: 'Transaction Type' },
      transactionTypeSpecificId: { label: 'Transaction Type Specific Id' },
      status: { label: 'Status' },
      regulatedTariffMin: { label: 'Regulated Tariff' },
      regulatedTariffMax: { label: 'Regulated Tariff' },
      onlyWithSurcharge: { label: 'Only With Surcharge' },
      surchargeMin: { label: 'Surcharge' },
      surchargeMax: { label: 'Surcharge' },
      amountMin: { label: 'Amount' },
      amountMax: { label: 'Amount' },
    },
  });
}

export type ShipperTransactionsPageParams = ReturnType<
  typeof useShipperTransactionsPageParams
>;
